"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BwmAboutOwner = void 0;
var _react = _interopRequireDefault(require("react"));
var _defaultAboutOwner = require("../../../defaults/quoteTools/defaultAboutOwner");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ownerEmailInput = _defaultAboutOwner.DefaultAboutOwner.ownerEmailInput,
  ownerPromoCodeInput = _defaultAboutOwner.DefaultAboutOwner.ownerPromoCodeInput,
  ownerPostCodeInput = _defaultAboutOwner.DefaultAboutOwner.ownerPostCodeInput,
  ownerTitleInput = _defaultAboutOwner.DefaultAboutOwner.ownerTitleInput,
  ownerFirstNameInput = _defaultAboutOwner.DefaultAboutOwner.ownerFirstNameInput,
  ownerLastNameInput = _defaultAboutOwner.DefaultAboutOwner.ownerLastNameInput,
  ownerMobileInput = _defaultAboutOwner.DefaultAboutOwner.ownerMobileInput,
  ownerMarketingFeedChannel = _defaultAboutOwner.DefaultAboutOwner.ownerMarketingFeedChannel,
  ownerBirthdateInput = _defaultAboutOwner.DefaultAboutOwner.ownerBirthdateInput;
var BwmAboutOwner = exports.BwmAboutOwner = _objectSpread(_objectSpread({}, _defaultAboutOwner.DefaultAboutOwner), {}, {
  heading: 'About you',
  showMembershipField: false,
  showEmailDisclaimer: true,
  mandatoryText: 'Mandatory fields',
  showMandatoryText: true,
  showBirthdate: false,
  emailDisclaimerText: function emailDisclaimerText(marketingPartner) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      className: "emailDisclaimer secondaryText"
    }, "By providing an email address, you understand that Bow Wow Meow Pty Ltd may use it to send you promotions or offers relating to products and services that may be available to you. You can opt out at any time.");
  },
  ownerTitleInput: _objectSpread(_objectSpread({}, ownerTitleInput), {}, {
    validation: {
      required: 'Please select your title'
    }
  }),
  ownerBirthdateInput: _objectSpread(_objectSpread({}, ownerBirthdateInput), {}, {
    validation: {
      required: 'Please enter your date of birth'
    }
  }),
  ownerFirstNameInput: _objectSpread(_objectSpread({}, ownerFirstNameInput), {}, {
    validation: {
      required: 'Please enter your first name'
    }
  }),
  ownerLastNameInput: _objectSpread(_objectSpread({}, ownerLastNameInput), {}, {
    validation: {
      required: 'Please enter your last name'
    }
  }),
  ownerMobileInput: _objectSpread(_objectSpread({}, ownerMobileInput), {}, {
    placeholder: 'Enter phone number',
    validation: _objectSpread(_objectSpread({}, ownerMobileInput.validation), {}, {
      required: 'Please enter your mobile phone'
    })
  }),
  ownerEmailInput: _objectSpread(_objectSpread({}, ownerEmailInput), {}, {
    placeholder: 'Enter email',
    validation: {
      required: 'Please enter your email',
      pattern: _objectSpread(_objectSpread({}, ownerEmailInput.validation.pattern), {}, {
        message: 'Email address is invalid'
      })
    }
  }),
  ownerPostCodeInput: _objectSpread(_objectSpread({}, ownerPostCodeInput), {}, {
    labelTooltip: 'This should be your residential postcode.',
    validation: {
      required: 'Please enter your postcode'
    }
  }),
  ownerPromoCodeInput: _objectSpread(_objectSpread({}, ownerPromoCodeInput), {}, {
    label: 'Promo code (optional)',
    placeholder: 'Enter promo code',
    labelTooltip: 'This code may have been provided to you via email or would appear on an advert or a brochure.'
  }),
  ownerMarketingFeedChannel: _objectSpread(_objectSpread({}, ownerMarketingFeedChannel), {}, {
    label: 'Where did you hear about us?'
  })
});